export enum ModulesEnum {
    Desconsiderar = 0,
    DesconsiderarDescription = 'Desconsiderar',

    RelatorioACI = 18,
    RelatorioACIDescription = 'Relatório de ACI',

    RelatorioSolicitacao = 19,
    RelatorioSolicitacaoDescription = 'Relatório de Solicitações',

    RelatorioEmissao = 20,
    RelatorioEmissaoDescription = 'Relatório de Emissões',

    RelatorioQuantidade = 21,
    RelatorioQuantidadeDescription = 'Relatório de Quantidade',

    RelatorioProdutividade = 22,
    RelatorioProdutividadeDescription = 'Relatório de Produtividade',

    RelatorioRevogacao = 23,
    RelatorioRevogacaoDescription = 'Relatório de Revogações',

    CapturaManual = 24,
    CapturaManualDescription = 'Captura Manual',

    NotificacaoEvento = 25,
    NotificacaoEventoDescription = 'Notificação Evento',

    ValidacaoExterna = 26,
    ValidacaoExternaDescription = 'Validação Externa',

    DocumentoFiscal = 27,
    DocumentoFiscalDescription = 'Documento Fiscal',

    Usuarios = 28,
    UsuariosDescription = 'Usuário',

    Renovacao = 29,
    RenovacaoDescription = 'Renovações',

    ConferenciaPrioridadeEnvio = 30,
    ConferenciaPrioridadeEnvioDescription = 'Prioridade de Envio',

    ConferenciaProtocoloBloqueado = 31,
    ConferenciaProtocoloBloqueadoDescription = 'Protocolos Bloqueados',

    Dashboard = 32,
    DashboardDescription = 'Dashboard',

    ControleProtocolo = 33,
    ControleProtocoloDescription = 'Controle Protocolo',

    Antifraude = 34,
    AntifraudeDescription = 'Antifraude',

    Produto = 35,
    ProdutoDescription = 'Produto',

    EntidadeSafe2Pay = 36,
    EntidadeSafe2PayDescription = 'EntidadeSafe2Pay',

    RelatorioVendas = 38,
    RelatorioVendasDescription = 'Relatório de Vendas',

    ComercialSolicitacao = 39,
    ComercialSolicitacaoDescription = 'Solicitação',

    Parceiro = 42,
    ParceiroDescription = 'Parceiro',

    Catalogo = 43,
    CatalogoDescription = 'Catálogo',

    RelatorioSafeID = 45,
    RelatorioSafeIDDescription = 'Relatório SafeID'
}
